/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhsince_Goethe14Inputs */

const en__field_enum_ikhsince_goethe14 = /** @type {(inputs: _Field_Enum_Ikhsince_Goethe14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiss. Mitarb. der Goethe-Universität`)
};

const de__field_enum_ikhsince_goethe14 = /** @type {(inputs: _Field_Enum_Ikhsince_Goethe14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiss. Mitarb. der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Wiss. Mitarb. der Goethe-Universität" |
*
* @param {_Field_Enum_Ikhsince_Goethe14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhsince_goethe14 = /** @type {((inputs?: _Field_Enum_Ikhsince_Goethe14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhsince_Goethe14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhsince_goethe14(inputs)
	return de__field_enum_ikhsince_goethe14(inputs)
});
export { _field_enum_ikhsince_goethe14 as "_field_enum_IKHSINCE_GOETHE" }